import { useQuery } from '@tanstack/react-query'
import { isOperator } from '../../../../../services/AccountService'
import { getCategories } from '../../../../../services/ApiService'
import { UTILS_KEYS } from '../api/api'

export const useGetCategories = () => {
  return useQuery({
    queryKey: [UTILS_KEYS.GET_CATEGORIES],
    queryFn: getCategories,
    staleTime: Infinity,
    enabled: !!isOperator(),
  })
}
